import { useEffect } from 'react';
import { IconClose, IconInfo } from './icons';

interface Props {
  visible: boolean;
  onClose: () => void;
  autoCloseMs?: number;
}

export function SequenceToast({ visible, onClose, autoCloseMs = 8000 }: Props) {
  useEffect(() => {
    if (!visible) return;
    const id = window.setTimeout(onClose, autoCloseMs);
    return () => window.clearTimeout(id);
  }, [visible, onClose, autoCloseMs]);

  if (!visible) return null;

  return (
    <div className="toast" role="status" aria-live="polite">
      <div className="toast-icon">
        <IconInfo />
      </div>
      <div className="toast-content">
        <div className="toast-title">Heads up</div>
        <div className="toast-body">
          Running these without the Core Message prompts first will give you generic results. You can
          still continue.
        </div>
      </div>
      <button type="button" className="toast-close" onClick={onClose} aria-label="Dismiss">
        <IconClose />
      </button>
    </div>
  );
}
